export default __webpack_public_path__ + "static/media/Pitch Black Pulverizer.23e43b76.png";